module.exports = "/static/assets/a07784032e83fe500c81b64d0585c3b9.png";